import GlobalUser from '../models/User';
import { Container } from '@airbus/components-react';
import React from "react";


class Home extends React.Component {

    constructor(){
        super();
        
        this.user = GlobalUser;
        //debugger;

    }

    /**
     * RENDERING
     * @returns dom
     */
     render() { return(
        <Container style={{paddingLeft:'40px'}}>
            
            <p>Bonjour {this.user.user_firstname} {this.user.user_name}</p>
            <p>Bienvenue sur le site d'administration de la SAJM. 
                Depuis cette application vous avez la possibilité:
                <ul>
                    <li>de gérer les comptes utilisateurs</li>
                    <li>de gérer les contacts et les abonnements aux articles publiés sur le site de la SAJM</li>
                    <li>de visualiser les dons reçus et générer des reçus fiscaux</li>
                    <li>de publier de nouveaux événements sur le site de la SAJM</li>
                    <li>d'envoyer des mails à des groupes d'utilisateurs</li>
                </ul>
            </p>

           
             
        </Container>
    )}

}

export default Home;